import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { Button } from 'shared/ui'
import { type PhoneCheckrStore } from 'pages/settings/ui/PhoneCheckr'

type IPhoneCheckSecondModalActionsProps = {
  store: PhoneCheckrStore
}

export const PhoneCheckSecondModalActions: FC<IPhoneCheckSecondModalActionsProps> = observer(
  ({ store }) => {
    const { backToFirstModal, activatePhoneCheckr } = store
    return (
      <>
        <Button
          typeBtn='contained'
          text='Back'
          size='medium'
          contained='secondary'
          onClick={backToFirstModal}
        />
        <Button typeBtn='contained' text='Save' size='medium' onClick={activatePhoneCheckr} />
      </>
    )
  }
)
